"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypeList = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireWildcard(require("../../styled-components.js"));
var _excluded = ["role", "listStyleReset", "condensedAll", "condensed"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var TypeListElement = _styledComponents["default"].ul.withConfig({
  displayName: "TypeList__TypeListElement",
  componentId: "sc-1jhixr6-0"
})(["", ";padding-inline:", ";padding-block-end:", ";margin-block:0;overflow-wrap:break-word;", ";"], (0, _index.rootStyle)(), function (props) {
  return props.$condensedAll ? '0' : '32px 0';
}, function (props) {
  return props.$condensed && '0';
}, function (props) {
  return props.$listStyleReset !== false && (0, _styledComponents.css)(["list-style-type:none;"]);
});
var TypeListComponent = /*#__PURE__*/_react["default"].forwardRef(function TypeList(_ref, ref) {
  var _ref$role = _ref.role,
    role = _ref$role === void 0 ? 'list' : _ref$role,
    _ref$listStyleReset = _ref.listStyleReset,
    listStyleReset = _ref$listStyleReset === void 0 ? false : _ref$listStyleReset,
    condensedAll = _ref.condensedAll,
    condensed = _ref.condensed,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(TypeListElement, Object.assign({
    role: role,
    ref: ref,
    $listStyleReset: listStyleReset,
    $condensedAll: condensedAll,
    $condensed: condensed
  }, props, {
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.TypeList
  }));
});
var typeListHelpers = {
  /**
   * @deprecated
   * Use `<TypeList />` instead (it's a `ul` element by default).
   */
  ul: /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
    return /*#__PURE__*/_react["default"].createElement(TypeListComponent, Object.assign({
      ref: ref
    }, props));
  }),
  /**
   * @deprecated
   * Use `<TypeList as="ol" />` instead.
   */
  ol: /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
    return /*#__PURE__*/_react["default"].createElement(TypeListComponent, Object.assign({
      as: "ol",
      ref: ref
    }, props));
  })
};

/**
 * TypeList displays child TypeListItems in a simple vertical list.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-typelist--docs) |
 * [Encore site](https://encore.spotify.net/web/components/text#text-lists) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/TypeList)
 */
var TypeList = exports.TypeList = Object.assign(TypeListComponent, typeListHelpers);